/**
 * 翻车机实时作业总览看板 — POST /api/produce/kanban/dumper-realtime-overview
 */
import request from '@/router/axios'

const API = '/api/produce/kanban/dumper-realtime-overview'

function unwrap(res) {
  const body = res && res.data
  if (body && Object.prototype.hasOwnProperty.call(body, 'data')) return body.data
  return body
}

export function fetchDumperRealtimeOverview(params = {}) {
  return request({
    url: API,
    method: 'post',
    data: params,
    headers: { 'Content-Type': 'application/json' }
  }).then(unwrap)
}
